import React, { ReactNode } from 'react';
type ButtonLinkProps = {
  href: string;
  children: ReactNode;
  variant?: 'primary' | 'ghost';
  size?: 'md' | 'sm';
  className?: string;
};
export function ButtonLink({
  href,
  children,
  variant = 'primary',
  size = 'md',
  className = ''
}: ButtonLinkProps) {
  const base = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-[10px] text-center font-bold transition-[background-color,border-color,filter] duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-soft focus-visible:ring-offset-2 focus-visible:ring-offset-ink';
  const sizes = size === 'sm' ? 'px-[17px] py-2.5 text-sm' : 'px-[22px] py-[13px] text-[15px]';
  const variants = variant === 'ghost' ? 'border border-line bg-transparent text-fg hover:border-accent' : 'bg-accent text-white hover:brightness-110';
  return <a href={href} className={`${base} ${sizes} ${variants} ${className}`} data-id="element-22" data-mp="2cigbfwjn8ucg">
      {children}
    </a>;
}